module.exports = __webpack_public_path__ + "assets/img/full-screen-image-1.e2eb1ef3.jpg";